<template>
    <div v-show="!!tagName" :class="`badge ${typeClass}`">
        <b-icon-hash v-if="!typeClass" class="icon icon-hash" />
        <div class="tags">
            <span class="tag" :title="tagName">{{ tagName }}</span>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watchEffect } from "vue";

const sizeComponent = ref(1);

const tagName = computed(() =>
    props.tag?.hasOwnProperty("name") ? props.tag.name : props.tag
);

const props = defineProps({
    tag: {
        type: Object || String,
        default: null,
    },
    typeClass: {
        type: String,
        default: "", // table
    },
});
</script>

<style lang="scss" scoped>
.badge {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    width: fit-content;
    padding-left: 0;
    font-size: 12px;
    font-weight: 600;
    color: var(--general-color);
    border-radius: 7px;
    box-shadow: 1px 1px 5px var(--general-color);
    // border: 1px solid var(--general-color);
    background-color: var(--general-opacity-color);
    transition: all 0.3s ease;
    // &:hover {
    //     background-color: var(--general-color);
    // }
    &.table {
        color: var(--border-primary-color);
        background: none;
        box-shadow: none;
        margin-top: -6px;
        margin-bottom: 0px;
        // max-width: 80px;
        .tags {
            display: flex;
            &::after {
                content: "]";
            }
            &::before {
                content: "[";
            }
            .tag {
                font-size: 13px;
                max-width: 90px;
                text-overflow: ellipsis;
                overflow: hidden;
                cursor: default;
            }
        }
    }
}

.icon {
    width: 20px;
    height: 20px;
    font-size: 18px;
    &-hash {
        margin-right: 2px;
        font-size: 16px;
        stroke-width: 2px;
        stroke-width: 0.5px;
        stroke: var(--general-color);
        color: var(--general-color);
    }
}
</style>
